// src/layouts/DashboardLayout.jsx
import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

const navLinkClass = ({ isActive }) =>
  `px-4 py-2 rounded-full font-medium ${
    isActive
      ? "bg-blue-600 text-white"
      : "text-gray-600 hover:bg-gray-100"
  }`;

export default function DashboardLayout() {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold">
              ED<span className="text-blue-600">BOT</span>
            </h1>
          </div>

          {/* barra de navegación: se envuelve en pantallas estrechas */}
          <nav className="flex flex-wrap items-center gap-2 justify-end ml-auto mt-4 md:mt-2">
            <NavLink to="" end                className={navLinkClass}>Diagnóstico</NavLink>
            <NavLink to="simulacros"          className={navLinkClass}>Simulacros</NavLink>
            <NavLink to="resultados"          className={navLinkClass}>Resultados</NavLink>

            {/* botón cerrar sesión */}
            <button
              onClick={logout}
              className="w-full md:w-auto mt-2 md:mt-0 md:ml-4
                         px-6 py-2 rounded-full font-semibold
                         bg-gray-100 text-blue-600 hover:bg-gray-200
                         transition duration-300 shadow-md hover:shadow-lg">
              Cerrar sesión
            </button>
          </nav>
        </div>
      </header>

      <main className="flex-grow bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

